import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {},
});

const ExampleNavigation = ({
  className,
  classes,
  navigationCollection,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {`[ExampleNavigation]: ${navigationCollection.link('self').url()}`}
    </Box>
  );
};

ExampleNavigation.defaultProps = {
  className: '',
};

ExampleNavigation.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  navigationCollection: PropTypes.object.isRequired,
};

export default withStyles(styles)(ExampleNavigation);
